import {StyleSheet} from 'react-native';
import {colorPalette, textStyles} from '../../../../../../theme';
import {styles} from 'src/theme';
export default StyleSheet.create({
  image: {
    width: '100%',
    height: 250,

    backgroundColor: '#eee',
  },
  description: {fontSize: 14, marginTop: 5, textAlign: 'center', color: '#555'},
  text: {
    color: '#303261',
    fontSize: 18,
    marginBottom: 15,
    fontFamily: styles.font.IranYekan[500],
    textAlign: 'center',
  },
  dotsWrapperTop: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 12,
  },
  dot: {
    width: 22,
    height: 8,
    borderRadius: 3, // دایره
    backgroundColor: '#ccc',
    marginHorizontal: 4,
  },
  activeDot: {
    backgroundColor: '#F34F42',
  },
  card: {
    marginBottom: 16,
    backgroundColor: '#fff',
  },
  Content: {
    alignItems: 'center',
  },
  iconbox: {
    flexDirection: 'row',
    justifyContent: 'center',

    width: '25%',
    marginBottom: 20,
  },
  box: {
    flexDirection: 'row-reverse',
    alignItems: 'flex-end',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginTop: 12,
  },
  boxDecription: {
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  boxzin: {
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    alignContent: 'center',
  },
  textbox: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '100%',
    marginBottom: 6,
    alignItems: 'center',
  },
  zintextbox: {
    justifyContent: 'center',
    width: '85%',
    marginBottom: 8,
    alignItems: 'flex-end',
    alignContent: 'center',
  },
  text_icon: {
    color: '#303261',
    fontSize: 13,
    fontFamily: styles.font.IranYekan[400],
    textAlign: 'flex-end',
    paddingRight: 5,
  },
  text_icon_zin: {
    color: '#303261',
    fontSize: 13,
    fontFamily: styles.font.IranYekan[400],
    textAlign: 'center',
  },
  text_Decription: {
    color: '#5A5A5A',
    fontSize: 13,
    fontFamily: styles.font.IranYekan[400],
    textAlign: 'center',
    paddingRight: 5,
  },

  loading: {
    width: '100%',
    height: '100%',
  },
});
